import { LazyLoad } from '@petconsole/pure-fe-mui';

const OrderAdmin = LazyLoad(() => import('./OrderAdmin'));

export { OrderAdmin };
